module.exports = __webpack_public_path__ + "img/task-12.e7f29397.png";